import Modal from"@wp/src/components/common/modal";import styled from"@emotion/styled";export const StyledPromptModal=styled(Modal)`
  .ant-modal-header {
    margin-right: 0px;
  }
`;